import React, { useContext, useEffect, useState } from 'react'
import { Group, Image, Layer, Rect, Stage, Text } from 'react-konva'
import { WemoloTypography } from '../../../../../components/Wemolo'
import { TrajectoryConfigurationContext } from '../../TrajectoryConfigurationContext'
import TrajectoryViewLayer from '../TrajectoryViewLayer/TrajectoryViewLayer'
import AnnotationFilter from './components/AnnotationFilter'
import ViewLayerFilter from './components/ViewLayerFilter'
import ViewLayerPolygon from './components/ViewLayerPolygon'
import styles from './Canvas.module.css'

function filterFiltersByViewModeIds(filters: any[], viewModeIds: string | any[]) {
    return filters
        .map((filter, index) => ({
            ...filter,
            viewModeId: index.toString()
        }))
        .filter((filter, index) => viewModeIds.includes(index.toString()))
}

const Canvas = () => {
    const trajectoryConfigurationContext = useContext(TrajectoryConfigurationContext)

    //STATES
    const [viewConfig, setviewConfig] = useState<any>([])
    const [viewConfigPolygon, setViewConfigPolygon] = useState<any>([])
    const [currentFilter, setCurrentFilter] = useState<any>()

    useEffect(() => {
        if (
            trajectoryConfigurationContext.currentFilter !== null &&
            trajectoryConfigurationContext.currentFilter !== undefined &&
            trajectoryConfigurationContext.filterData
        ) {
            setCurrentFilter(trajectoryConfigurationContext.filterData[trajectoryConfigurationContext.currentFilter])
        } else {
            setCurrentFilter(null)
        }
    }, [trajectoryConfigurationContext.currentFilter, trajectoryConfigurationContext.filterData])

    useEffect(() => {
        if (trajectoryConfigurationContext.viewMode && trajectoryConfigurationContext.filterData) {
            const viewModeIds = trajectoryConfigurationContext.viewMode.map((viewMode) => viewMode.id)
            const filteredFilters = filterFiltersByViewModeIds(trajectoryConfigurationContext.filterData, viewModeIds)
            setviewConfig(filteredFilters)
        }
    }, [trajectoryConfigurationContext.filterData, trajectoryConfigurationContext.viewMode])

    useEffect(() => {
        if (trajectoryConfigurationContext.viewMode && trajectoryConfigurationContext.data.polygonData) {
            const viewModeIds = trajectoryConfigurationContext.viewMode.map((viewMode) => viewMode.id)
            if (viewModeIds.includes('polygon')) {
                setViewConfigPolygon(trajectoryConfigurationContext.data.polygonData)
            } else {
                setViewConfigPolygon([])
            }
        }
    }, [trajectoryConfigurationContext.viewMode, trajectoryConfigurationContext.data.polygonData])

    const handleContextUpdate = (filter: any) => {
        if (trajectoryConfigurationContext.currentFilter != null) {
            trajectoryConfigurationContext.setFilterData(
                'properties',
                filter.properties,
                trajectoryConfigurationContext.currentFilter
            )
        }
    }

    if (trajectoryConfigurationContext.image === undefined) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.captionWrapper}>
                    <WemoloTypography variant="label-xsmall" tag="span">
                        {trajectoryConfigurationContext.imageSize.text}
                    </WemoloTypography>
                </div>
                <div className={styles.column}>
                    <Stage
                        width={trajectoryConfigurationContext.imageSize.width}
                        height={trajectoryConfigurationContext.imageSize.height}
                    >
                        <Layer>
                            <Group>
                                <Rect
                                    width={trajectoryConfigurationContext.imageSize.width}
                                    height={trajectoryConfigurationContext.imageSize.height}
                                    fill="black"
                                />
                                <Text
                                    text={trajectoryConfigurationContext.imageSize.text}
                                    x={10}
                                    y={10}
                                    fill="transparent"
                                    fontSize={0}
                                />
                            </Group>
                            <ViewLayerFilter
                                imageSize={trajectoryConfigurationContext.imageSize}
                                viewConfig={viewConfig}
                            ></ViewLayerFilter>
                            <ViewLayerPolygon
                                imageSize={trajectoryConfigurationContext.imageSize}
                                polygon={viewConfigPolygon}
                            ></ViewLayerPolygon>
                            <TrajectoryViewLayer
                                trajectory_data={trajectoryConfigurationContext.trajectoryViewCoordinates}
                                trajectories_vehicle={trajectoryConfigurationContext.vehicleDetectionsTrajectoryView}
                                trajectories_lp={trajectoryConfigurationContext.lpDetectionsTrajectoryView}
                                best_detection={trajectoryConfigurationContext.bestDetection}
                                enable_view={trajectoryConfigurationContext.enableTrajectoryView}
                            />
                            <AnnotationFilter
                                handleContextUpdate={handleContextUpdate}
                                currentFilter={currentFilter}
                                imageSize={trajectoryConfigurationContext.imageSize}
                            ></AnnotationFilter>
                        </Layer>
                    </Stage>
                </div>
            </div>
        )
    } else {
        return (
            <div className={styles.wrapper}>
                <div className={styles.captionWrapper}>
                    <WemoloTypography variant="label-xsmall" tag="span">
                        {trajectoryConfigurationContext.imageSize.text}
                    </WemoloTypography>
                </div>
                <div className={styles.imageColumn}>
                    <Stage
                        width={trajectoryConfigurationContext.imageSize.width}
                        height={trajectoryConfigurationContext.imageSize.height}
                    >
                        <Layer>
                            <Image
                                image={trajectoryConfigurationContext.image}
                                x={0}
                                y={0}
                                width={trajectoryConfigurationContext.imageSize.width}
                                height={trajectoryConfigurationContext.imageSize.height}
                            />
                            <Group>
                                <Rect width={0} height={0} fill="black" />
                                <Text
                                    text={trajectoryConfigurationContext.imageSize.text}
                                    x={10}
                                    y={10}
                                    fill="transparent"
                                    fontSize={0}
                                />
                            </Group>
                            <ViewLayerFilter
                                imageSize={trajectoryConfigurationContext.imageSize}
                                viewConfig={viewConfig}
                            ></ViewLayerFilter>
                            <ViewLayerPolygon
                                imageSize={trajectoryConfigurationContext.imageSize}
                                polygon={viewConfigPolygon}
                            ></ViewLayerPolygon>
                            <TrajectoryViewLayer
                                trajectory_data={trajectoryConfigurationContext.trajectoryViewCoordinates}
                                trajectories_vehicle={trajectoryConfigurationContext.vehicleDetectionsTrajectoryView}
                                trajectories_lp={trajectoryConfigurationContext.lpDetectionsTrajectoryView}
                                best_detection={trajectoryConfigurationContext.bestDetection}
                                enable_view={trajectoryConfigurationContext.enableTrajectoryView}
                            />
                            <AnnotationFilter
                                handleContextUpdate={handleContextUpdate}
                                currentFilter={currentFilter}
                                imageSize={trajectoryConfigurationContext.imageSize}
                            ></AnnotationFilter>
                        </Layer>
                    </Stage>
                </div>
            </div>
        )
    }
}

export default Canvas
